module.exports = __webpack_public_path__ + "img/cloud-rain-2-moon.9b48cabf.svg";